import { BreadCrumbs } from '../Layout/Header/BreadCrumbs';
import { HeaderContainer } from '../Layout/HeaderContainer';

import { PageContainer } from '@components/PageContainer';
import { routes } from '@config/routes';

export const CustomerStatements = () => {
  return (
    <PageContainer>
      <BreadCrumbs
        links={[
          { link: 'Revenue and Collections', to: `` },
          { link: 'Customer Statement', to: `${routes.CUSTOMER_STATEMENT}` },
        ]}
      />
      {/* change this to main content */}
      <HeaderContainer>This is Customer Statement</HeaderContainer>
      {/* change this to main content */}
    </PageContainer>
  );
};
